module.exports = __webpack_public_path__ + "static/audi-803c4cd58d3dcc524bdaf20dbfe43bbc.jpg";